// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1526":"95c8c86610e52a77","2888":"091861a883e15031"}[chunkId] + ".css";
};